import React from 'react'
import { Tag } from '@driftt/tide-core'
import moment from 'moment'

export const ExampleDriftContact = {
  id: '123-456',
  name: 'Dolf Lundgren',
  first_name: 'Dolf',
  last_name: 'Lundgren',
  alias: 'Drago',
  primaryIdentiy: 'dolf.lundgren@theexpendablesmovie.com',
  _cql_score: 2,
  _cql_source: 'Leadbot',
  original_medium: 'Search',
  original_source: 'Google',
  original_term: 'Cool products',
  original_entrance_page_url: 'http://www.yoursite.com',
  original_entrance_page_title: 'Cool Product Dot Com',
  original_referer_url: 'http://www.google.com',
  attributes: {
    city: 'Los Angeles',
    country: 'United States',
    employment_name: 'The Expendables',
    employment_role: 'Independent Contractor',
    employment_title: 'Problem Solver',
    display_name: 'Dolf Lundgren',
    last_active: moment().format('MM/DD/YYYY hh:mm'),
    last_contacted: moment().format('MM/DD/YYYY hh:mm'),
    start_date: moment().format('MM/DD/YYYY hh:mm'),
    state: 'California',
    _classification: 'Hot Lead',
    phone: '(555)555-5555'
  },
  defaults: {
    STRING: 'Some sample content',
    DATETIME: '01/01/2018 12:32:17',
    BOOLEAN: 'True',
    NUMERIC: '123'
  },
  account: '',
  createdAt: moment().format('MM/DD/YYYY hh:mm'),
  customerId: 123456,
  email: 'dolf.lundgren@theexpendablesmovie.com',
  locale: 'Hollywood, CA USA',
  timeZone: 'America/California',
  'twitter': 'therealdolf',
  'tags': (<Tag text='Followed by Jon Snow…' />),
  '# segments': '42',
  'Lead Stage': 'Hot Lead',
  'phone number': '(555)555-5555',
  'seniority': 'Add seniortiy',
  'linkedin': '/in/therealdolf',
  'time zone': 'America/California',
}
